import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsSectionExtendedContent } from '@/learnpaths-assigned-page/components/LearnpathsSectionExtendedContent/LearnpathsSectionExtendedContent'
import useAssignedLearnpath from '@/learnpaths-assigned/hooks/useAssignedLearnpath'

import { retainListFilters } from './learnpaths'

export const Route = createFileRoute(
  '/_learning/_company/_list/learnpaths/view/$learnpathId',
)({
  search: {
    middlewares: [retainListFilters],
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { learnpathId } = Route.useParams()
  const navigate = Route.useNavigate()
  const learnpath = useAssignedLearnpath({ learnpathId })

  if (!learnpath) {
    return null
  }

  return (
    <LearnpathsSectionExtendedContent
      handleClose={() =>
        navigate({
          to: '/learnpaths',
          search: true,
          state: { restoreFilters: true },
        })
      }
      learnpath={learnpath}
    />
  )
}
